/** @format */
import { request } from '@power/runtime-vue3';

const basePath = '/power-factory';
export function getBusinessManageList(data) {
	return request(
		{
			url: `${basePath}/business-object/list`,
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function getServeList(data) {
	return request({
		url: `${basePath}/business-object/serve/list`,
		method: 'post',
		data,
	});
}

export function getDataProcessList(data) {
	return request({
		url: `${basePath}/data-processing/list`,
		method: 'post',
		data,
	});
}
